import navigationRoutes from "./navigationRoutes";
import HomePage from "@/projects/NPS/Stepper/pages/HomePage/home";
import Signup from "@/projects/NPS/Stepper/pages/SignUp";
import NewSubscriberRegistration from "@/projects/NPS/Stepper/pages/SubscriberRegistration";
import SubscriberRegistrationSummary from "@/projects/NPS/Stepper/pages/SubscriberRegistrationSummary";
import DigilockerCallbackPage from "@/projects/NPS/Stepper/pages/Digilocker/DigilockerCallbackPage";
import PranSuccessScreen from "@/projects/NPS/Stepper/pages/PranSuccessScreen";
import PaymentFailedScreen from "@/projects/NPS/Stepper/pages/PaymentFailedScreen";
import PrivacyPolicyPage from "@/projects/NPS/Stepper/pages/PrivacyPolicy";
import TermsAndConditionsPage from "@/projects/NPS/Stepper/pages/TermsAndConditions";
import Calculators from "@/projects/Calculators/CalculatorsHomePage";
import {
  SIPCalculator,
  LumpsumCalculator,
  FDCalculator,
  TaxCalculator,
  PPFCalculator,
  EMICalculator,
  NPSCalculator,
  SSYCalculator,
  RDCalculator,
  InflationCalculator,
  GSTCalculator,
  CAGRCalculator,
  SWPCalculator,
  EPFCalculator,
  HRACalculator,
  RetirementCalculator,
} from "@/projects/Calculators/components/calculators";

const protectedRoutes = [
  {
    path: navigationRoutes.NEW_SUBSCRIBER_REGISTRATION,
    element: NewSubscriberRegistration,
    name: "New Subscriber Registration",
  },
  {
    path: navigationRoutes.SUBSCRIBER_REGISTRATION_SUMMARY,
    element: SubscriberRegistrationSummary,
    name: "Subscriber Registration Summary",
  },
  {
    path: navigationRoutes.DIGILOCKER_CALLBACK,
    element: DigilockerCallbackPage,
    name: "Digilocker Callback",
  },
  {
    path: navigationRoutes.PRAN_SUCCESS_SCREEN,
    element: PranSuccessScreen,
    name: "Pran Success Screen",
  },
  {
    path: navigationRoutes.PAYMENT_FAILED_SCREEN,
    element: PaymentFailedScreen,
    name: "Payment Failed Screen",
  },
];

// Public routes that don't require authentication
const publicRoutes = [
  {
    path: navigationRoutes.LOGIN,
    element: HomePage,
    name: "NPS",
  },
  {
    path: navigationRoutes.SIGNUP,
    element: Signup,
    name: "Sign Up",
  },
  {
    path: navigationRoutes.PRIVACY_POLICY,
    element: PrivacyPolicyPage,
    name: "Privacy Policy",
  },
  {
    path: navigationRoutes.TERMS_AND_CONDITIONS,
    element: TermsAndConditionsPage,
    name: "Terms And Conditions",
  },
  {
    path: navigationRoutes.CALCULATORS,
    element: Calculators,
    name: "Calculators",
  },
  {
    path: navigationRoutes.CALCULATORS_SIP,
    element: SIPCalculator,
    name: "SIP Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_LUMPSUM,
    element: LumpsumCalculator,
    name: "Lumpsum Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_FD,
    element: FDCalculator,
    name: "FD Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_SWP,
    element: SWPCalculator,
    name: "SWP Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_PPF,
    element: PPFCalculator,
    name: "PPF Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_EPF,
    element: EPFCalculator,
    name: "EPF Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_NPS,
    element: NPSCalculator,
    name: "NPS Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_SSY,
    element: SSYCalculator,
    name: "SSY Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_RECURRING_DEPOSIT,
    element: RDCalculator,
    name: "Recurring Deposit Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_TAX,
    element: TaxCalculator,
    name: "Income Tax Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_HRA,
    element: HRACalculator,
    name: "HRA Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_EMI,
    element: EMICalculator,
    name: "EMI Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_GST,
    element: GSTCalculator,
    name: "GST Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_CAGR,
    element: CAGRCalculator,
    name: "CAGR Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_INFLATION,
    element: InflationCalculator,
    name: "Inflation Calculator",
  },
  {
    path: navigationRoutes.CALCULATORS_RETIREMENT,
    element: RetirementCalculator,
    name: "Retirement Calculator",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: protectedRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
export { navigationRoutes };
